var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Linking } from 'react-native';
import { inject } from '../../../Data/Decorators/Inject';
import { injectable } from '../../../Data/Decorators/Injectable';
import { reactive } from '../../Decorators/Reactive';
import { IGetAppUpdateUseCaseType } from '../../../Domain/UseCases/Application/GetAppUpdateUseCase/IGetAppUpdateUseCase';
let AppUpdateScreenViewModel = class AppUpdateScreenViewModel {
    constructor(getAppUpdate) {
        this.getAppUpdate = getAppUpdate;
        this.viewData = {
            version: this.getAppUpdate.execute().value,
            loading: false,
            error: ''
        };
        this.submit = this.submit.bind(this);
        this.dismissError = this.dismissError.bind(this);
        this.getAppUpdate.execute().observe(this, version => this.updateViewData({ version }));
    }
    dismissError() {
        this.updateViewData({ error: '' });
    }
    submit() {
        var _a, _b;
        if (!((_a = this.viewData.version) === null || _a === void 0 ? void 0 : _a.download_url)) {
            return;
        }
        Linking.canOpenURL((_b = this.viewData.version) === null || _b === void 0 ? void 0 : _b.download_url)
            .then(canOpen => {
            if (!canOpen) {
                return Promise.reject(new Error('Can\'t open link!'));
            }
            return Linking.openURL(this.viewData.version.download_url);
        })
            .catch(error => this.updateViewData({ error: error.message }));
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], AppUpdateScreenViewModel.prototype, "viewData", void 0);
AppUpdateScreenViewModel = __decorate([
    injectable(),
    __param(0, inject(IGetAppUpdateUseCaseType)),
    __metadata("design:paramtypes", [Object])
], AppUpdateScreenViewModel);
export { AppUpdateScreenViewModel };
